import { Select } from "antd";
import React from "react";

const CurrencyComponent = ({ onChange, value, name }) => {
  return (
    <Select
      name={name}
      id="cargoValue-currency"
      onChange={onChange}
      value={value}
      options={[
        { value: "USD", label: "USD" },
        { value: "EUR", label: "EUR" },
      ]}
      showSearch
    ></Select>
  );
};

export default CurrencyComponent;
